import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ChatProvider } from "@/context/ChatContext";
import Chat from "@/pages/Chat";
import Cash from "@/pages/Cash";
import Archive from "@/pages/Archive";
import Impegnative from "@/pages/Impegnative";
import ImpegnativaDetail from "@/pages/ImpegnativaDetail";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Appointments from "@/pages/Appointments";
import AppointmentDetail from "@/pages/AppointmentDetail";
import Agenda from "@/pages/Agenda";
import Settings from "@/pages/Settings";
import Account from "@/pages/Account";
import AuditLog from "@/pages/AuditLog";
import Privacy from "@/pages/Privacy";
import Warehouse from "@/pages/Warehouse";
import WhLot from "@/pages/WhLot";
import WhItem from "@/pages/WhItem";
import WhSearch from "@/pages/WhSearch";
import WhMovements from "@/pages/WhMovements";
import WhCode from "@/pages/WhCode";
import WhQuick from "@/pages/WhQuick";
import { can } from "@/lib/roles";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <div className="h-8 w-8 rounded-full border-2 border-[var(--primary)] border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname + loc.search }} />;
  return <Layout>{children}</Layout>;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function NeedPerm({ perm, children }) {
  const { user } = useAuth();
  if (user && !can(user, perm)) return <Navigate to="/" replace />;
  return children;
}

function LoginRoute() {
  const { user } = useAuth();
  const loc = useLocation();
  if (user) return <Navigate to={loc.state?.from || "/"} replace />;
  return <Login />;
}

function App() {
  return (
    <AuthProvider>
      <ChatProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/" element={<Protected><Appointments /></Protected>} />
          <Route path="/appuntamenti/:id" element={<Protected><AppointmentDetail /></Protected>} />
          <Route path="/agenda" element={<Protected><Agenda /></Protected>} />
          <Route path="/chat" element={<Protected><Chat /></Protected>} />
          <Route path="/incassi" element={<Protected><NeedPerm perm="cash"><Cash /></NeedPerm></Protected>} />
          <Route path="/impegnative" element={<Protected><Impegnative /></Protected>} />
          <Route path="/impegnative/:id" element={<Protected><ImpegnativaDetail /></Protected>} />
          <Route path="/magazzino" element={<Protected><Warehouse /></Protected>} />
          <Route path="/magazzino/lotti/:id" element={<Protected><WhLot /></Protected>} />
          <Route path="/magazzino/articoli/:id" element={<Protected><WhItem /></Protected>} />
          <Route path="/magazzino/cerca" element={<Protected><WhSearch /></Protected>} />
          <Route path="/magazzino/movimenti" element={<Protected><WhMovements /></Protected>} />
          <Route path="/magazzino/a/:code" element={<Protected><WhCode /></Protected>} />
          <Route path="/magazzino/raffica" element={<Protected><WhQuick /></Protected>} />
          <Route path="/archivio" element={<Protected><AdminOnly><Archive /></AdminOnly></Protected>} />
          <Route path="/impostazioni" element={<Protected><AdminOnly><Settings /></AdminOnly></Protected>} />
          <Route path="/registro" element={<Protected><AdminOnly><AuditLog /></AdminOnly></Protected>} />
          <Route path="/privacy" element={<Protected><AdminOnly><Privacy /></AdminOnly></Protected>} />
          <Route path="/account" element={<Protected><Account /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </ChatProvider>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
